// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gourgeist_small: PokeData = {
  "id": 10030,
  "name": "gourgeist-small",
  "height": 7,
  "weight": 95,
  "base_experience": 173,
  "types": [
    PokeType.GHOST,
    PokeType.GRASS
  ],
  "api_moves": [
    "leech-seed",
    "razor-leaf",
    "confuse-ray",
    "explosion",
    "scary-face",
    "pain-split",
    "shadow-ball",
    "trick",
    "astonish",
    "bullet-seed",
    "worry-seed",
    "seed-bomb",
    "shadow-sneak",
    "phantom-force",
    "trick-or-treat",
    "moonblast"
  ],
  "moves": [
    "razor-leaf",
    "confuse-ray",
    "scary-face",
    "shadow-ball",
    "bullet-seed",
    "shadow-sneak",
    "phantom-force",
    "moonblast",
    "vine-whip",
    "spectral-snatch",
    "lick",
    "shadow-dagger",
    "spectral-chain"
  ],
  "evolution_chain": {
    "id": 365,
    "item": null,
    "species": [
      {
        "name": "pumpkaboo",
        "order": 710,
        "types": [
          PokeType.GHOST,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gourgeist",
        "order": 711,
        "types": [
          PokeType.GHOST,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 710,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 118,
    "speed": 152,
    "ability_power": 130
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
